import * as PIXI from "pixi.js";
import {app, events, gameData, ticker} from "../../utils/pixiApp";
import TWEEN from "@tweenjs/tween.js";
import {getDeviceMedia} from "../../utils/sizes";

const sizes = {
    font: {
        size: 14
    },
    web: {
        height: 80,
        fontSize: 14,
        paddingRight: 165,
    },
    mobile: {
        height: 56,
        fontSize: 15,
        paddingRight: 18,
    }
}

const style = new PIXI.TextStyle({
    fontFamily: "Montserrat, sans-serif",
    fontSize: 14,
    fill: '#19567b',
    align: 'left',
    fontWeight: 'bold',
    paddingRight: 80
});

const padding = {left: 12, top: 8, right: 8, bottom: 8}

export class Balance extends PIXI.Container {

    constructor(h) {
        super();
        this.mediaScreen = getDeviceMedia(app.screen.width)
        this.position.x = app.screen.width - sizes[this.mediaScreen].paddingRight
        this.position.y = h / 2;
        this.baseWidth = 97
        this.symbolWidth = 8;
        this.count = gameData.getGameData('userBalance')
        console.log('init', this.count)
        this.text = new PIXI.Text({ text:  String(this.count).replace(".",",") + ' BYN', style });
        this.text.anchor.set(0, .5)
        this.text.position.x = padding.left
        this.text.position.y = 0
        this.text.zIndex = 2
        this.text.style.fill = this.mediaScreen === 'web' ? '#19567b' :'#FFF'

        this.bg = new PIXI.Graphics()
            .roundRect(0, -20, this.baseWidth + this.symbolWidth, 40, 8)
            .fill('rgba(199, 223, 238, 1)');
        this.bg.alpha = 1;
        if(this.mediaScreen !== 'web') {
            this.bg.alpha = 0;
        }

        this.img = this.mediaScreen === 'web' ? new PIXI.Sprite(PIXI.Texture.from('exclude')) : new PIXI.Sprite(PIXI.Texture.from('excludeMobile'));
        this.img.setSize(24,24)
        this.img.anchor.set(0, .5)
        this.img.position.x = this.bg.position.x + this.bg.width - padding.right - this.img.width
        this.img.position.y = 0;
        this.text.anchor.set(0, .5)
        this.bg.eventMode = 'static';
        this.bg.cursor = 'pointer'
        this.bg.on('pointerdown', () => {
            window.parent.postMessage(
                JSON.stringify({
                    type: 'REDIRECT',
                    data: { to: '/balance' },
                }),
                '*',
            );
        })
        this.bg.on('pointerover', this.onHover.bind(this))
        this.bg.on('pointerout', this.onLeave.bind(this))

        this.addChild(this.bg,this.img,this.text)
        this.setPosition()

        this.TWEEN = TWEEN;
        ticker.add((dt) => {
            this.TWEEN.update(dt)
        })

        events.onGameDataChange(this.setCount.bind(this))
        events.onPrizeCompleate(this.setSumAnimate.bind(this))

        events.onScreenResizeEvent(this.resizeView.bind(this))


        const data = gameData.getGameData()
        this.count = String(data.userBalance).replace(".",",")
    }

    setCount(eventArray) {
        if(eventArray.indexOf('userBalance') !== -1) {
            const data = gameData.getGameData()
            this.count =  String(data.userBalance).replace(".",",")
        }

        this.bg.width = String(this.count).length * 7 + this.baseWidth;
        this.img.position.x = this.bg.position.x + this.bg.width - padding.right - this.img.width
        this.text.text = this.count + ' BYN'
    }

    setPosition() {
        const pos = String(this.count).length * 7 + this.baseWidth;
        this.position.x = app.screen.width - sizes[this.mediaScreen].paddingRight - pos
        this.position.y = sizes[this.mediaScreen].height / 2
        this.bg.width = pos;
        this.img.position.x = this.bg.position.x + this.bg.width - padding.right - this.img.width

        window.balancePosition = this.bg.getGlobalPosition()
    }

    setSumAnimate() {
        const prize = gameData.getGameData('prize')
        const balance = gameData.getGameData('userBalance')
        const sumAnimate1 = new this.TWEEN.Tween({scale: 1}).to({scale: 1.1}, 500).onUpdate((obj, num) => {
            // this.scale.set(obj.scale)
            this.text.style.fontSize = sizes.font.size + num * 2
            this.text.text = `${String((Number(balance) + (prize / 10) * (num * 10)).toFixed(2)).replace(".",",")} BYN`
        })

        const sumAnimate2 = new this.TWEEN.Tween({scale: 1.1}).to({scale: 1}, 500).onUpdate((obj, num) => {
            // this.scale.set(obj.scale)
            this.text.style.fontSize = sizes.font.size + 1 - num * 2
        })

        sumAnimate1.chain(sumAnimate2)
        sumAnimate1.start()
    }

    onHover() {
        this.setBackground(true);
    }

    onLeave() {
        this.setBackground()
    }

    setBackground(alpha) {
        const color = alpha ? 'rgba(199, 223, 238, .8)' : 'rgba(199, 223, 238, 1)'
        this.bg.clear();
        this.bg.roundRect(0, -20, this.baseWidth + this.symbolWidth, 40, 8)
            .fill(color);
    }

    resizeView() {
        const mediaScreen = getDeviceMedia(app.screen.width)
        if(this.mediaScreen !== mediaScreen) {
            window.balancePosition = {x: this.position.x, y: this.position.y + 10}
            this.text.style.fill = mediaScreen === 'web' ? '#19567b' :'#FFFFFF'
            this.mediaScreen = mediaScreen;
            this.img.texture = this.mediaScreen === 'web' ? PIXI.Texture.from('exclude') : PIXI.Texture.from('excludeMobile');
            if(mediaScreen === 'web') {
                this.setPosition();
                this.bg.alpha = 1;
            } else {
                this.bg.alpha = 0;
            }
        }
        if(mediaScreen !== 'web') {
            window.balancePosition = {x: this.position.x + 30, y: this.position.y + 10}
            this.setPosition();
        }
    }
}